var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlkimaFooterRaketeMobil(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 257,
    height: 114,
    viewBox: "0 0 257 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.7538 120.414L74.2977 100.042L157.665 53.6213L163.17 61.9552L87.7538 120.414Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.779 46.4384C188.247 61.3212 160.022 58.3349 160.022 58.3349C160.41 56.9228 168.928 30.8224 190.885 16.3193C213.417 1.43655 236.175 -3.85417 241.642 4.42284C247.186 12.8148 233.311 31.5556 210.779 46.4384Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.619 70.489L149.381 53.4752C149.002 52.9004 149.349 52.1758 149.884 51.9871L152.027 51.232L166.645 46.3651L173.934 57.4011L163.721 68.9356L162.185 70.6104C161.762 71.2199 160.999 71.0638 160.619 70.489Z",
    fill: "#FC6076"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.721 68.9357L152.027 51.2321L166.76 46.2892L174.049 57.3253L163.721 68.9357Z",
    fill: "#FC6076"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.474 38.221C174.474 38.221 159.04 28.6023 134.293 43.1317C133.067 43.776 133.862 45.7282 135.239 45.3138C145.989 42.3409 162.347 41.6083 168.345 50.69L174.474 38.221Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.702 38.5661C174.702 38.5661 159.267 28.9474 134.52 43.4768C133.295 44.1211 134.089 46.0733 135.466 45.6589C146.216 42.686 162.574 41.9534 168.573 51.0351L174.702 38.5661Z",
    fill: "#FC6076"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.345 53.1652C184.345 53.1652 187.134 71.1365 164.058 88.195C162.984 89.0693 161.501 87.5727 162.422 86.4685C169.376 77.7478 176.47 62.9902 170.471 53.9085L184.345 53.1652Z",
    fill: "#FC6076"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.662 47.0121C188.13 61.8948 159.904 58.9085 159.904 58.9085C160.292 57.4964 168.81 31.396 190.767 16.8929C213.299 2.01015 236.058 -3.28056 241.525 4.99645C247.107 13.1975 233.308 32.0533 210.662 47.0121Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.662 47.0107C188.13 61.8935 159.904 58.9072 159.904 58.9072L241.525 4.99514C247.107 13.1962 233.308 32.052 210.662 47.0107Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.833 30.3862C214.58 33.1957 208.853 32.025 206.044 27.7715C203.234 23.5181 204.405 17.7913 208.658 14.9818C212.912 12.1723 218.639 13.3431 221.448 17.5966C224.258 21.85 223.087 27.5767 218.833 30.3862Z",
    fill: "#D12C3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.755 30.7684C214.502 33.5779 208.775 32.4072 205.965 28.1537C203.156 23.9002 204.327 18.1735 208.58 15.364C212.834 12.5545 218.56 13.7253 221.37 17.9787C224.179 22.2322 223.009 27.9589 218.755 30.7684Z",
    fill: "#FC6076"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.692 43.6883C184.002 44.1439 183.163 43.8728 182.783 43.298C182.327 42.6083 182.598 41.7688 183.173 41.3891C183.863 40.9335 184.702 41.2046 185.082 41.7794C185.538 42.4691 185.382 43.2327 184.692 43.6883Z",
    fill: "#3E3E53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.768 43.8038C184.078 44.2594 183.239 43.9883 182.859 43.4135C182.404 42.7238 182.675 41.8843 183.25 41.5046C183.939 41.049 184.779 41.3201 185.158 41.8949C185.538 42.4697 185.458 43.3482 184.768 43.8038Z",
    fill: "#3E3E53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.44 39.8939C189.75 40.3495 188.91 40.0785 188.531 39.5037C188.075 38.8139 188.346 37.9744 188.921 37.5947C189.611 37.1391 190.45 37.4102 190.83 37.985C191.285 38.6748 191.129 39.4383 190.44 39.8939Z",
    fill: "#3E3E53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.515 40.0087C189.825 40.4643 188.986 40.1932 188.606 39.6184C188.15 38.9287 188.421 38.0892 188.996 37.7096C189.686 37.254 190.525 37.525 190.905 38.0998C191.285 38.6746 191.09 39.6291 190.515 40.0087Z",
    fill: "#3E3E53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.188 36.0969C195.498 36.5525 194.658 36.2815 194.279 35.7067C193.823 35.0169 194.094 34.1774 194.669 33.7978C195.359 33.3422 196.198 33.6132 196.578 34.188C197.033 34.8778 196.877 35.6413 196.188 36.0969Z",
    fill: "#3E3E53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.264 36.2119C195.574 36.6675 194.735 36.3964 194.355 35.8216C193.899 35.1319 194.17 34.2924 194.745 33.9127C195.435 33.4571 196.274 33.7282 196.654 34.303C197.034 34.8777 196.839 35.8322 196.264 36.2119Z",
    fill: "#3E3E53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.92 29.5034C214.356 31.8574 209.699 30.8058 207.421 27.357C205.067 23.7933 206.119 19.136 209.567 16.858C213.016 14.58 217.788 15.5557 220.066 19.0044C222.344 22.4532 221.484 27.1495 217.92 29.5034Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.314 25.1141C219.472 23.8538 219.134 22.5914 218.374 21.4419C216.552 18.6829 212.734 17.9023 209.975 19.7247C208.825 20.484 208.019 21.5123 207.555 22.8095C207.639 20.9375 208.602 19.1457 210.211 18.0826C212.97 16.2602 216.788 17.0408 218.611 19.7997C219.864 21.4482 219.971 23.3592 219.314 25.1141Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 99.635,
    cy: 81.0843,
    r: 3.65771,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 152.5,
    cy: 100.5,
    r: 4.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.9463,
    cy: 98.1536,
    r: 4.26733,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.2992,
    cy: 89.9238,
    r: 2.74328,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.2722,
    cy: 102.116,
    r: 1.52404,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144.048,
    cy: 94.0482,
    r: 3.04809,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.474,
    cy: 113.089,
    r: 14.9356,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 79.8225,
    cy: 96.02,
    r: 14.9356,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 116.704,
    cy: 112.175,
    r: 11.5827,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 149.319,
    cy: 121.014,
    r: 10.0587,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132.25,
    cy: 114.918,
    r: 10.6683,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.256,
    cy: 102.421,
    r: 15.8501,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.186,
    cy: 77.7314,
    r: 2.13366,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.3628,
    cy: 108.822,
    r: 9.44908,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.9724,
    cy: 94.1911,
    r: 7.01061,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75.5552,
    cy: 116.747,
    r: 12.4972,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.4972,
    cy: 117.015,
    r: 12.4972,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.93,
    cy: 113.699,
    r: 19.8126,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 169.851,
    y1: 73.9681,
    x2: 148.703,
    y2: 35.5163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494792,
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC6076"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 169.851,
    y1: 73.9668,
    x2: 158.482,
    y2: 55.1373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494792,
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC6076"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 257,
    height: 114,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlkimaFooterRaketeMobil);
export default __webpack_public_path__ + "static/media/alkima-footer-rakete-mobil.d1066b991b44fd0926ba2133a69490f4.svg";
export { ForwardRef as ReactComponent };